module.exports = __webpack_public_path__ + "img/kehu_01.e2bac271.png";